
import AvatarComponent from "@/components/elements/avatar/avatar.component.vue";
import { Component, Vue } from "vue-property-decorator";
@Component({
  name: "e-second-component",
  components: { AvatarComponent },
})
export default class ESecondComponent extends Vue {}
